module.exports = __webpack_public_path__ + "static/media/rest.0962ec1e.svg";